import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../utils/NumberUtils';
import _ from 'lodash';
import cx from 'classnames';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import BrowserUtils from '../../utils/BrowserUtils';

/**
 * @todo
 * This component has quality issues that would benefit from a refactor
 * to meet accepted best practices.
 */
class AccountComponent extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.getAccountBalances = this.getAccountBalances.bind(this);
    this.getAccountDisplayNumber = this.getAccountDisplayNumber.bind(this);
    this.getIcon = this.getIcon.bind(this);
    this.displayAvailableAmount = this.displayAvailableAmount.bind(this);

    this.state = {
      curAmount: 0,
      availAmount: 0,
      load: false,
      error: false,
      activeFlag: true,
    };
  }

  componentWillMount() {
    this.setState({ savingPotAccIndex: SavingsPotsStore.getAccountIndex() });
  }

  componentDidMount() {
    this.getAccountBalances();
  }

  componentWillReceiveProps() {
    if (!this.props.savingPot) {
      this.getAccountBalances();
    } else {
      this.setState({ savingPotAccIndex: SavingsPotsStore.getAccountIndex() });
    }
  }

  onClick(index) {
    if (this.props.savingPot) {
      SavingPotsActionCreator.getClickedAccount(
        this.props.index,
        this.props.data,
        this.state.activeFlag
      );
    } else if (typeof this.props.onClick === 'function') {
      this.props.onClick(index);
    }
  }

  getAccountBalances() {
    // const accDetails = AccountsStore.getAccountDetail(this.props.data.id);
    // if (accDetails && !accDetails.errCode) {
    const accDetails = this.props.data;
    if (accDetails.balances) {
      accDetails.balances.map((balance) => {
        switch (balance.type) {
          case 'current':
            this.setState({ curAmount: balance.amount });
            break;
          case 'available':
            this.setState({ availAmount: balance.amount });
            break;
          default: {
            break;
          }
        }
        return false;
      });
    }
  }

  /**
   * Displays the account number
   */
  getAccountDisplayNumber() {
    // to mask the number incase of credit card
    if (this.props.data.type === 'credit_card') {
      let creditcardNumber = _.replace(
        this.props.data.number,
        '************',
        'xxxxxxxxxxxx'
      );
      creditcardNumber = _.split(creditcardNumber, '-');
      const creditcard = NumberUtils.formatCreditCard(creditcardNumber[0]);
      return ` ${creditcard}`;
    } else {
      // to display number in case of normal account number and sort code format
      const accountNumber = _.split(this.props.data.number, '-');
      const sortcode = NumberUtils.formatSortCode(accountNumber[0]);
      return `${accountNumber[1]} | ${sortcode}`;
    }
  }

  getIcon() {
    if (this.props.data.showIcon) {
      if (this.props.data.type === 'current') {
        return 'warning';
      } else if (this.props.data.type === 'savings') {
        return 'attention';
      }
    }
  }

  displayAvailableAmount(amount) {
    if (
      this.props.data.type === 'current' ||
      this.props.data.type === 'credit_card' ||
      this.props.data.type === 'savings'
    ) {
      return (
        <div>
          <h2>
            {amount[0]}.
            <sub>
              {amount[1]} {this.props.content.accountBalanceCurrent}
            </sub>
          </h2>
          <h4>
            {NumberUtils.appendCurrency('{}', this.state.availAmount)}{' '}
            {this.props.content.accountBalanceAvailable}
          </h4>
        </div>
      );
    } else {
      return (
        <div>
          <br />
          <h2>
            {amount[0]}.
            <sub>
              {amount[1]} {this.props.content.accountBalanceCurrent}
            </sub>
          </h2>
        </div>
      );
    }
  }

  render() {
    const index = (this.props.index % 10) + 1;
    const amount = _.split(
      NumberUtils.appendCurrency('{}', this.state.curAmount),
      '.'
    );
    let classNames;
    if (this.props.savingPot) {
      if (
        this.state.savingPotAccIndex === index ||
        BrowserUtils.isMobileView()
      ) {
        classNames = cx(
          'account',
          `account-${index}`,
          'active',
          this.getIcon()
        );
      } else {
        classNames = cx('account', `account-${index}`);
      }
    } else {
      classNames = cx('account', `account-${index}`, 'active', this.getIcon());
    }

    return (
      <a className={classNames} onClick={this.onClick} id={this.props.data.id}>
        <h3>{this.props.data.displayName}</h3>
        <h5>{this.getAccountDisplayNumber()}</h5>
        {this.displayAvailableAmount(amount)}
      </a>
    );
  }
}

AccountComponent.propTypes = {
  data: PropTypes.object,
  content: PropTypes.object,
  onClick: PropTypes.func,
  index: PropTypes.number,
  savingPot: PropTypes.bool,
};

export { AccountComponent };
